export function trimToTime(dateTime) {
    if(!dateTime ) return dateTime;
    const parts = dateTime.split("T")
    if(parts.length <1) return dateTime;
    return parts[1];
}